/**
 * Short locale date for list rows (aligned with Governance source drives).
 *
 * @param {string | null | undefined} dateString
 * @returns {string}
 */
export const formatDateShort = (dateString) => {
  if (!dateString) return '—';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return dateString;
  }
};
